import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  my-2
  border-t

  border-t-white/20
`);

export default function DrawerDividerItem(_props) {
  return (
    <hr className={CLASS_NAMES} />
  );
}
